import { executeCommandWithJobCompletion } from "../jobCompletion";
import { translate } from "../translate";
import * as TranslationsKeys from "../locale/translationsKeys";
import { stringFormat } from "../helpers";
import { dialogConfirmationButtonClassName, dialogCancelButtonClassName } from "../dialogConstants";
import { trackEvent } from "../../Features/Analytics";

export async function publishHandler(
    publishUrl: string,
    publishPreviewUrl: string,
    destinationName: string,
    language: string,
    destinationUniqueId: string,
    activationCode: string,
    isExternalUser: boolean,
    isPublishPreview: boolean,
    getJobUrl: string,
    onCompletion: ((jobGuid: string) => void) | undefined = undefined,
    shouldConfirm: boolean,
    isPublishCloneWithPreviewWording: boolean
) {
    if (shouldConfirm) {
        bootbox.confirm({
            title: stringFormat(translate(TranslationsKeys.Global_PublishConfirmationTitle), destinationName),
            message: translate(TranslationsKeys.Global_PublishConfirmationMessage),
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Publish),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                publishHandlerInternal();
            }
        });
    } else {
        publishHandlerInternal();
    }

    function publishHandlerInternal() {
        const publishPreviewMessage = stringFormat(
            translate(TranslationsKeys.Global_PublishPreviewInformationMessage),
            destinationName,
            activationCode
                ? stringFormat(translate(TranslationsKeys.Global_PublishInformationMessage_ActivationCode), activationCode)
                : "",
            isExternalUser
                ? translate(TranslationsKeys.Global_PublishInformationMessage_ExternalUserPreviewSuffix)
                : "",
            '<img src="https://s3.amazonaws.com/data.smart-guide.org/data/static_resources/images/Content_Creator_Activation_QR-code.jpg" srcset="https://s3.amazonaws.com/data.smart-guide.org/data/static_resources/images/Content_Creator_Activation_QR-code.svg" />'
        );

        const publishMessage = `
<div class="text-center my-2">
    <h5 class="mx-auto" style="width: 70%;">
        Scan QR code to view the destination in the mobile app
    </h5>
    <img src="/api/DeepLinkQRCode/GetDestinationDeepLinkQrCode?destinationUniqueId=${destinationUniqueId}&language=${language}"
         class="my-2"
         width="165px"
         height="165px"
         />
</div>
<div class="d-flex">
    <i class="far fa-question-circle align-self-center mx-3"></i>
    If the destination doesn't show or you don't see the changes please go to Home page in the app and RELOAD data by swiping down. Scan the QR code once again after that.
</div>
<hr />
<div>
    <div class="text-center">
        Do you have a problem with QR code?
        <a data-toggle="collapse" href="#collapseTheOtherWay" role="button" aria-expanded="false" aria-controls="collapseTheOtherWay">
            Try other way <i class="fas fa-chevron-down"></i>
        </a>
    </div>
    <div class="collapse" id="collapseTheOtherWay">
        <div class="row mt-3">
            <div class="col">
                <img src="/img/publish_1.png"
                     class="d-block border border-2 border-success rounded"
                     style="border-width: 2px !important;"
                     width="225px"
                     />
                1. Go to Home page in the app and <b>RELOAD</b> data by swiping down
            </div>
            <div class="col pl-0">
                <img src="/img/publish_2.png"
                     class="d-block border border-2 border-success rounded"
                     style="border-width: 2px !important;"
                     width="225px"
                     />
                2. ${stringFormat(translate(TranslationsKeys.Global_PublishInformationMessage_ActivationCode), activationCode)}
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                3. View your changes in the mobile app and then you can <b>Request Publish to App</b> or make another changes in CMS.
            </div>
        </div>
    </div>
</div>
`;

        trackEvent(isPublishPreview ? 'destinationPreviewLaunched' : 'destinationPublishLaunched', { destinationName });

        executeCommandWithJobCompletion(
            isPublishPreview
                ? publishPreviewUrl
                : publishUrl,
            getJobUrl,
            null,
            isExternalUser, 
            isPublishPreview
                ? publishPreviewMessage
                : publishMessage,
            onCompletion
        );
    }
}

